// extracted by mini-css-extract-plugin
export default {"btn":"buttonTransparent__btn___LDSC8","dark":"buttonTransparent__dark___y2gTx","btn-glass":"buttonTransparent__btn-glass___In308","light":"buttonTransparent__light___xpJW4"};